module.exports = __webpack_public_path__ + "static/img/4.0c983925.png";